import { useMemo } from 'react';
import { useCaseReviewsDataQuery } from '@/queries/case';
import { Case } from '@/api/apis/case';
import { useCaseDetails } from '@/hooks/useCaseDetails';

export const useCaseDetailsWithReviews = (): Case => {
  const caseData = useCaseDetails();

  const { data: caseReviewsData } = useCaseReviewsDataQuery(caseData.caseId);

  if (!caseReviewsData) {
    throw new Error('No route builder case data provided');
  }

  return useMemo(
    () => ({
      ...(caseData as Case),
      ...caseReviewsData,
    }),
    [caseData, caseReviewsData],
  );
};
